var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor fixed z-90 block top-0 left-0 w-3 h-3 rounded-full pointer-events-none will-change-transform opacity-0",class:("bg-" + _vm.color)})}
var staticRenderFns = []

export { render, staticRenderFns }